export const startRoutes = [
  {
    label: "Orders",
    value: "order-list"
  },
  {
    label: "Profile",
    value: "profile"
  },
  {
    label: "Configuration",
    value: "configuration"
  },
  {
    label: "Organisations",
    value: "organisations"
  },
  {
    label: "Missions",
    value: "mission"
  },
  {
    label: "Mobile",
    value: "mobile"
  },
  {
    label: "Quasar",
    value: "quasar"
  },
];



// WEBPACK FOOTER //
// ./src/helpers/start-routes.js